'use strict';

const StorageAdapter = require('./StorageAdapter');

/**
 * LocalStorage storage adapter for Browsers.
 * @class
 * @extends StorageAdapter
 * @memberof AthomCloudAPI
 */
class StorageAdapterBrowser extends StorageAdapter {

  static LOCAL_STORAGE_KEY = 'homey-api';

  /**
   * @returns {Promise<object>}
   */
  async get() {
    try {
      return JSON.parse(window.localStorage.getItem(this.constructor.LOCAL_STORAGE_KEY) || '{}');
    } catch (err) {
      return {};
    }
  }

  /**
   * @param {object} value
   * @returns {Promise<void>}
   */
  async set(value) {
    window.localStorage.setItem(this.constructor.LOCAL_STORAGE_KEY, JSON.stringify(value));
  }

}

module.exports = StorageAdapterBrowser;
